import React from 'react'
import LoadingScreen from './LoadingScreen'


const asyncComponent = (getComponent , placeholder = LoadingScreen) => {
    return class AsyncComponent extends React.Component {
        static Component = null
        state = { Component: AsyncComponent.Component }

        componentWillMount() {
            if (!this.state.Component) {
                getComponent().then(Component => {
                    AsyncComponent.Component = Component
                    this.setState({ Component })
                })
            }
        }

        render() {
            const { Component } = this.state
            const PlaceholderComponent = placeholder
            if (Component) {
                return <Component { ...this.props } />
            }
            return <PlaceholderComponent />
        }
    }
}

export default asyncComponent


// WEBPACK FOOTER //
// ./src/AsyncComponent.js